import { useState } from "react";
import AvailableTours from "./AvailableTours";
import MyTours from "./MyTours";

export default function GuideDashboard() {
    const [tab, setTab] = useState("available");

    return (
        <div style={{ padding: 20 }}>
            <h1>Guide Dashboard</h1>

            {/* NAV */}
            <div style={{ display: "flex", gap: 10 }}>
                <button onClick={() => setTab("available")}>
                    Available Tours
                </button>

                <button onClick={() => setTab("mine")}>
                    My Tours
                </button>
            </div>

            <hr />

            {/* CONTENT */}
            {tab === "available" && <AvailableTours />}
            {tab === "mine" && <MyTours />}
        </div>
    );
}